<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<div [ngClass]="{'border': !isFinalStepColumn}">

    <div (mouseout)="delegateTooltipToggle(false)"
         (mouseover)="delegateTooltipToggle(true)"
         [ngClass]="{'incomplete': !model.isCompleted, 'bold': isFinalStep}"
         class="title"
         data-cy="claim-progress-title">{{model.description}}</div>

    <div class="step-bar" data-cy="claim-progress-step-bar">
        <div (mouseout)="delegateTooltipToggle(false)"
             (mouseover)="delegateTooltipToggle(true)"
             [ngClass]="{'is-start': isStart, 'incomplete': !model.isCompleted}"
             class="inner-bar {{model.code}} {{titlePosition}}"
             data-cy="claim-progress-inner-bar"></div>
    </div>
</div>

